<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
/*浏览器样式初始化*/
body,div,dl,dt,dd,ul,ol,li,h1,h2,h3,h4,h5,h6,pre,code,form,fieldset,legend,input,button,textarea,p,blockquote,th,td {
  margin:0;
  padding:0;
}
input,textarea,button {
  border: none;
  outline: none;
  background: none;
  font-family: 'microsoft yahei', Helvetica, Arial, sans-serif;
}
h1, h2, h3, h4, h5, h6 {
  font-weight:normal; font-size:100%;
}
address, caption, cite, code, dfn, em, strong, th, var {
  font-style:normal;
  font-weight:normal;
}
a {
  color: #2c3e50; text-decoration: none;
}
a:hover {
  text-decoration: none;
}
img {
  border:none;
}
ol,ul,li {
  list-style:none;
}
table {
  border-collapse:collapse;
}
html {
  overflow-y: hidden;
}
::-ms-clear,::-ms-reveal{display:none;}
*::-webkit-scrollbar {
  width: 12px;
  height: 10px;
}
*::-webkit-scrollbar-thumb {
  height: 30px;
  background-color: #999;
  -webkit-border-radius: 7px;
  outline: 2px solid #fff;
  outline-offset: -2px;
  border: 2px solid #fff;
}
*::-webkit-scrollbar-track-piece {
  background-color: #fff;
  -webkit-border-radius: 3px;
}
#app {
  font-family: 'microsoft yahei', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>



// WEBPACK FOOTER //
// src/App.vue